/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthActionType } from 'store/actionTypes/auth-action-type';
import { IAction } from 'store/state/app-state';
import { IGeneralState } from 'store/state/auth-state';

export const GeneralReducer = (state: IGeneralState = null, action: IAction<any>): IGeneralState => {
    switch (action.type) {
        case AuthActionType.PATIENT_SHOW_LOADER:
            return {
                ...state,
                showLoader: action.payload,
            };
        case AuthActionType.PATIENT_UPDATE_NOTIFICATION_COUNT:
            return {
                ...state,
                isReadNotification: action.payload,
            };
        case AuthActionType.SET_SERVICE_DOWN:
            return {
                ...state,
                isServiceDown: action.payload,
            };
        default:
            return state;
    }
};
